(function(){

  const onPageView = () => {

    document.querySelectorAll('.lottie-on-page-view').forEach(function(player){
      player.play()
    })
  }

  window.addEventListener('load', function(){
    onPageView()
  })

  const scrollSync = () => {
    const scrollSyncLotties = [
      {
        id: '#scrollSync1',
        actions: [
          {
            visibility: [0, 1.0],
            type: 'playOnce'
          }
        ]
      },
      {
        id: '#scrollSync2',
        actions: [
          {
            visibility: [0, 1.0],
            type: 'playOnce'
          }
        ]
      },
      {
        id: '#scrollSync3',
        actions: [
          {
            visibility: [0, 1.0],
            type: 'playOnce'
          }
        ]
      }
    ]

    scrollSyncLotties.forEach(function(config) {
      LottieInteractivity.create({
        player: config.id,
        mode: 'scroll',
        actions: config.actions
      })
    })
  }

  scrollSync()

})()
